<section class="relative flex w-screen h-screen overflow-hidden">
  <ng-container *ngTemplateOutlet="menuSection" />
  <div class="w-full overflow-hidden h-full flex flex-col">
    <app-top-bar
      [header]="currentChildMenu()?.name || currentMenu()?.name || ''"
      [description]="currentChildMenu()?.description || currentMenu()?.description || ''" />
    <div #container class="flex-1 w-full h-full overflow-y-auto bg-base-200 p-6">
      <router-outlet />
    </div>
  </div>
</section>

<ng-template #menuSection>
  <app-side-menu title="피그뱅크 관리자" logo="/icon.png" class="md:block hidden">
    @for (menu of menus(); track $index) {
      @if (menu.children && menu.children.length > 0) {
        <app-side-menu-item-group [active]="currentMenu() === menu" [label]="menu.name" [icon]="menu.icon!">
          @for (child of menu.children; track $index) {
            @let visible = child.super ? user()?.role === 'SUPER_ADMIN' : true;

            @if (visible) {
              <app-side-menu-item-child (click)="navigate(child)" [active]="currentChildMenu() === child">{{
                child.name
              }}</app-side-menu-item-child>
            }
          }
        </app-side-menu-item-group>
      } @else {
        <app-side-menu-item (click)="navigate(menu)" [active]="currentMenu() === menu" [icon]="menu.icon!" [showArrow]="menu.showArrow ?? false">{{
          menu.name
        }}</app-side-menu-item>
      }
    }
  </app-side-menu>
</ng-template>
